/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Communitytitle1Inputs */

const id_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berbasis Komunitas`)
};

const ms_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didorong Komuniti`)
};

const da_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskabsdrevet`)
};

const de_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Getrieben`)
};

const en_us2_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Driven`)
};

const es_es2_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por la comunidad`)
};

const es_mx2_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por la comunidad`)
};

const fil_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinapatakbo ng Komunidad`)
};

const fr_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piloté par la communauté`)
};

const it_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guidato dalla community`)
};

const hu_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közösség által működtetett`)
};

const nl_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-gestuurd`)
};

const no_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fellesskapsdrevet`)
};

const pl_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napędzane przez społeczność`)
};

const pt_br2_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientado pela comunidade`)
};

const pt_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientado pela comunidade`)
};

const ro_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condus de comunitate`)
};

const fi_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisön ylläpitämä`)
};

const sv_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-driven`)
};

const vi_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều hành bởi cộng đồng`)
};

const tr_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk Odaklı`)
};

const cs_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řízeno komunitou`)
};

const bg_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ръководен от общността`)
};

const ru_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управляется сообществом`)
};

const uk_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спільнота`)
};

const ar_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدفوع من المجتمع`)
};

const hi_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समुदाय संचालित`)
};

const th_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขับเคลื่อนโดยชุมชน`)
};

const ja_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティ主導`)
};

const zh_cn2_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区驱动`)
};

const zh_hant1_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社群驅動`)
};

const ko_about_communitytitle1 = /** @type {(inputs: About_Communitytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티 기반`)
};

/**
* | output |
* | --- |
* | "Community Driven" |
*
* @param {About_Communitytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_communitytitle1 = /** @type {((inputs?: About_Communitytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Communitytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_communitytitle1(inputs)
	if (locale === "ms") return ms_about_communitytitle1(inputs)
	if (locale === "da") return da_about_communitytitle1(inputs)
	if (locale === "de") return de_about_communitytitle1(inputs)
	if (locale === "en-US") return en_us2_about_communitytitle1(inputs)
	if (locale === "es-ES") return es_es2_about_communitytitle1(inputs)
	if (locale === "es-MX") return es_mx2_about_communitytitle1(inputs)
	if (locale === "fil") return fil_about_communitytitle1(inputs)
	if (locale === "fr") return fr_about_communitytitle1(inputs)
	if (locale === "it") return it_about_communitytitle1(inputs)
	if (locale === "hu") return hu_about_communitytitle1(inputs)
	if (locale === "nl") return nl_about_communitytitle1(inputs)
	if (locale === "no") return no_about_communitytitle1(inputs)
	if (locale === "pl") return pl_about_communitytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_about_communitytitle1(inputs)
	if (locale === "pt") return pt_about_communitytitle1(inputs)
	if (locale === "ro") return ro_about_communitytitle1(inputs)
	if (locale === "fi") return fi_about_communitytitle1(inputs)
	if (locale === "sv") return sv_about_communitytitle1(inputs)
	if (locale === "vi") return vi_about_communitytitle1(inputs)
	if (locale === "tr") return tr_about_communitytitle1(inputs)
	if (locale === "cs") return cs_about_communitytitle1(inputs)
	if (locale === "bg") return bg_about_communitytitle1(inputs)
	if (locale === "ru") return ru_about_communitytitle1(inputs)
	if (locale === "uk") return uk_about_communitytitle1(inputs)
	if (locale === "ar") return ar_about_communitytitle1(inputs)
	if (locale === "hi") return hi_about_communitytitle1(inputs)
	if (locale === "th") return th_about_communitytitle1(inputs)
	if (locale === "ja") return ja_about_communitytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_communitytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_communitytitle1(inputs)
	return ko_about_communitytitle1(inputs)
});
export { about_communitytitle1 as "about.communityTitle" }